import { ChevronDownIcon, ChevronUpIcon } from '@moia-dev/pace-icons'
import { Heading } from '@moia-dev/pace-web'
import { useState } from 'react'
import type { BackofficeAreas } from '../types/BackofficeArea'
import { useGetAreaTranslation } from '../useGetAreaTranslation'
import {
  MaybeRestrictedNavigationItem,
  MaybeRestrictedSection,
} from './MaybeRestrictedNavigationItem'

type NavigationDrawerSectionProps = {
  label?: string
  onAreaChange?: VoidFunction
  open: boolean
  areas: BackofficeAreas
}
export const NavigationDrawerSection = ({
  label,
  onAreaChange,
  open,
  areas,
}: NavigationDrawerSectionProps) => {
  const [isSectionOpen, setIsSectionOpen] = useState(true)
  const { getAreaTranslation } = useGetAreaTranslation()
  const hideSectionLabel = !open || label === undefined || label === ''

  // If any required right of an area matches, the section is allowed to be visible
  const allowedRights = areas.map(area => area.requiredRight)

  const navigation = areas.map(area =>
    area.NavigationComponent ? (
      <MaybeRestrictedNavigationItem
        key={area.id}
        requiredRight={area.requiredRight}
      >
        <area.NavigationComponent
          label={getAreaTranslation(area.id)}
          open={open}
          onClick={onAreaChange}
        />
      </MaybeRestrictedNavigationItem>
    ) : null,
  )

  if (hideSectionLabel) {
    return (
      <MaybeRestrictedSection allowedRights={allowedRights}>
        <div>{navigation}</div>
      </MaybeRestrictedSection>
    )
  }

  return (
    <MaybeRestrictedSection allowedRights={allowedRights}>
      <div>
        <button
          css={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 var(--space-3)',
            marginBottom: 'var(--space-2)',
            textTransform: 'uppercase',
            width: '100%',
            svg: {
              width: 20,
              height: 20,
            },
          }}
          onClick={() => setIsSectionOpen(!isSectionOpen)}
        >
          <Heading
            className="sectionHeading"
            css={{
              color: 'var(--color-content-reduced)',
              lineHeight: '20px',
            }}
            size="sm"
          >
            {label}
          </Heading>
          {isSectionOpen ? (
            <ChevronUpIcon
              css={theme => ({
                color: theme.semantic.ColorActionSecondaryDefault,
              })}
            />
          ) : (
            <ChevronDownIcon
              css={theme => ({
                color: theme.semantic.ColorActionSecondaryDefault,
              })}
            />
          )}
        </button>
        {isSectionOpen && <div>{navigation}</div>}
      </div>
    </MaybeRestrictedSection>
  )
}
